import { Injectable } from '@angular/core';
import { RocosSDK } from '@dronedeploy/rocos-js-sdk';
import { environment } from '@env/environment';
import { HttpError, StateService } from '@shared/services';
import { ReplaySubject } from 'rxjs';
import { nativeFetch } from './native-fetch';

@Injectable({
  providedIn: 'root',
})
export class RocosSdkClientService {
  public client: RocosSDK;
  public client$ = new ReplaySubject<RocosSDK>(1);

  constructor(private stateService: StateService) {}

  public login(token: string) {
    if (this.client) {
      this.client.getAuthService().setToken(token);
      return;
    }

    this.client = new RocosSDK({
      url: new URL(environment.api.url).host,
      token,
      transport: environment.api.transport,
      // Read the telemetry stream through a fetch captured before Datadog RUM patches window.fetch
      // (RUM's response cloning otherwise stalls the long-lived stream). Applies to both transports
      // with rocos-js-sdk >= 3.1.2. See native-fetch.ts.
      fetch: nativeFetch,
      hooks: {
        http: {
          onResponse: (response) => {
            switch (response.status) {
              case 401:
                this.stateService.gotUnauthorizedError(new HttpError('Unauthorized', response.status));
                break;
              case 403:
                this.stateService.gotForbiddenError(new HttpError('Forbidden', response.status));
                break;
            }
          },
        },
      },
    });
    this.client$.next(this.client);
  }
}
